import React, { useEffect, useState, useRef, useCallback, forwardRef } from 'react';
import KBDefaultsViewer from '../aiKnowledgeBase/KBDefaultsViewer.js';
import KBGroupManager from '../aiKnowledgeBase/KBGroupManager.js';
import LearnFromConversations from '../aiKnowledgeBase/LearnFromConversations.js';
import { updateAiChatSetting, getKnowledeBaseDetails } from '../../../redux/knowledgeBase/actionCreator.js';
import { alertModal } from '../../../components/modals/antd-modals';
import { Row, Col, Form, Checkbox, Switch, Input, Divider, InputNumber, Select, Modal, Table } from 'antd';
import { Main, BasicFormWrapper } from '../../styled';
import { AddUser } from '../style';

import {
  fetchEmailTemplates,
  fetchHostListing,
  updateListingAdditionalMessage,
  updateScheduler,
  fetchChannel,
  updateChannelMessage,
} from '../../../redux/manageSettings/actionCreator';
import Spinner from '../../common/Spinner.js';
import HttpStatus from '../../../utility/status.enum';
import { useDispatch } from 'react-redux';
import { Button } from '../../../components/buttons/buttons';
import { useParams } from 'react-router-dom';
import Notification from '../../../utility/notification.js';
import { Link } from 'react-router-dom';
import { UserTableStyleWrapper } from '../style';
import { TableWrapper } from '../../styled';
import Heading from '../../../components/heading/heading.js';
import { Cards } from '../../../components/cards/frame/cards-frame';
import cmsIcon from '../../../../src/static/img/dark-edit-icon.svg';
import { useCMS } from '../../../utility/useCMS.js';
import Functions from '../../../utility/functions.js';

const TemplateConfig = forwardRef(({ onConfigUpdated, initialSection = 'messages', onSectionChange }, ref) => {
  const { backEndPrefix, hostLoginRoleID, adminLoginRoleID } = global;
  const { channelMessage, smsMessage, emailMessage, upsellMarkettingGroupId } = global;
  const dispatch = useDispatch();
  const hostSlug = useParams()?.hostSlug ?? '';
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [loginUser, setLoginUser] = useState([]);

  const [templateSlug, setTemplateSlug] = useState([]);
  const [isSchedulerEnabled, setIsSchedulerEnabled] = useState(false);

  const [schedulerTemplateList, setSchedulerTemplateList] = useState([]);
  const [listingLists, setListingLists] = useState([]);
  // Sorted copy used only by the "Select Listings" popup so that re-ordering for display
  // never mutates listingLists — keeping additionalMessages positional indices stable.
  const [sortedListingLists, setSortedListingLists] = useState([]);

  const [isVariablePopupOpen, setIsVariablePopupOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [additionalMessages, setAdditionalMessages] = useState([]);
  const [originalMessages, setOriginalMessages] = useState([]);
  const [updateLoading, setUpdateLoading] = useState(false);

  const [isListingSelectionPopupOpen, setIsListingSelectionPopupOpen] = useState(false); // Model Flag
  const [selectedListings, setSelectedListings] = useState({}); // Data structure of object to enlist all selected listings slug for particular message template
  const [currentTemplateSlug, setCurrentTemplateSlug] = useState(null); // Selected slug (booking_confirmation, before_checkin, day_of_checkin_1 etc)
  const [selectionMode, setSelectionMode] = useState({}); // Flag used for check all listing are selected OR Not to respective message section
  const [preListingData, setPreListingData] = useState({}); // Backup of previous listing selections for popup cancel/restore.
  const [messageCMSMessage, setMessageCMSMessage] = useState('');
  const placeholderHappyGuestLink = '[HAPPY_GUEST_LINK]';
  const [form] = Form.useForm();
  const [channelForm] = Form.useForm();
  const textAreaRefs = useRef({});
  const { fetchCMSCommonFunction } = useCMS();

  const [channelList, setChannelList] = useState([]);
  const [channelMessages, setChannelMessages] = useState([]);
  const [originalChannelMessages, setOriginalChannelMessages] = useState([]);

  const [isChannelPopupOpen, setIsChannelPopupOpen] = useState(false);
  const [channelEditingIndex, setChannelEditingIndex] = useState(null);
  const [activeTab, setActiveTab] = useState({});
  const smsTwilioValidationIndex = useRef({});
  const [refreshComponent, setRefreshComponent] = useState(false);
  const [showCmsPopupInfo, setShowCmsPopupInfo] = useState(false);
  const [isSexOffededEnable, setIsSexOffededEnable] = useState(false); // State for checking the host have enables configuration for sex offender.
  const [cmsContent, setCmsContent] = useState(false);
  const [activeSection, setActiveSection] = useState(initialSection);
  const [isAiChatEnabled, setIsAiChatEnabled] = useState(false);
  const [isKbEnabled, setIsKbEnabled] = useState(false);
  const [savedIsAiChatEnabled, setSavedIsAiChatEnabled] = useState(false);
  const [savedIsKbEnabled, setSavedIsKbEnabled] = useState(false);
  const [isKbSaving, setIsKbSaving] = useState(false);
  const [kbCmsContent, setKbCmsContent] = useState(null);
  const [aiEnableListings, setAiEnableListings] = useState([]);
  const [aiAllListingsSelected, setAiAllListingsSelected] = useState(false);
  const [showAiListingPopup, setShowAiListingPopup] = useState(false);
  const [tempAiListings, setTempAiListings] = useState([]);
  const [preAiListings, setPreAiListings] = useState([]);
  const [kbSupportEmail, setKbSupportEmail] = useState('');
  const [learnModalVisible, setLearnModalVisible] = useState(false);

  const fetchKbSettings = async () => {
    const payload = { request_type: 1, content_type: 4 };
    if (hostSlug) payload.host_slug = hostSlug;
    const [res, cms] = await Promise.all([
      dispatch(getKnowledeBaseDetails(payload)),
      fetchCMSCommonFunction(40),
    ]);
    if (res?.status === 200 && res?.other_data?.ai_settings) {
      const { is_ai_chat_enable, is_kb_enable, ai_enable_listings, is_all_selected, support_email } = res.other_data.ai_settings;
      setIsAiChatEnabled(is_ai_chat_enable === 1);
      setSavedIsAiChatEnabled(is_ai_chat_enable === 1);
      setIsKbEnabled(is_kb_enable === 1);
      setSavedIsKbEnabled(is_kb_enable === 1);
      try {
        const parsed = typeof ai_enable_listings === 'string' ? JSON.parse(ai_enable_listings) : ai_enable_listings;
        setAiEnableListings(Array.isArray(parsed) ? parsed : []);
      } catch {
        setAiEnableListings([]);
      }
      setAiAllListingsSelected(!!is_all_selected);
      if (support_email) setKbSupportEmail(support_email);
    }
    if (cms) setKbCmsContent(cms);
    // Ensure listingLists is populated for the AI Chat listing selector
    if (!listingLists.length) {
      fetchHostListings();
    }
  };

  useEffect(() => {
    if (activeSection === 'kb') {
      fetchKbSettings();
    }
  }, [activeSection]);

  const handleSectionChange = (section) => {
    if (onSectionChange) {
      onSectionChange(section);
    } else {
      setActiveSection(section);
    }
  };

  const handleKbSave = async () => {
    setIsKbSaving(true);
    try {
      const payload = {
        is_ai_chat_enable: isAiChatEnabled ? 1 : 2,
        is_kb_enable: isKbEnabled ? 1 : 2,
      };
      if (loginUser.role_id === adminLoginRoleID) {
        payload.host_slug = hostSlug;
        payload.ai_enable_listings = aiEnableListings;
        payload.is_all_selected = aiAllListingsSelected;
      }
      if (loginUser.role_id === hostLoginRoleID) {
        payload.ai_enable_listings = aiEnableListings;
        payload.is_all_selected = aiAllListingsSelected;
      }
      const res = await dispatch(updateAiChatSetting(payload));
      if (res?.status === HttpStatus.HTTP_OK) {
        setSavedIsAiChatEnabled(isAiChatEnabled);
        setSavedIsKbEnabled(isKbEnabled);
      }
      onConfigUpdated(true);
    } finally {
      setIsKbSaving(false);
    }
  };

  const openAiListingPopup = () => {
    const selectedSlugs = new Set(aiEnableListings);
    const selected = [], notSelected = [];
    for (const item of listingLists) {
      (selectedSlugs.has(item.slug) ? selected : notSelected).push(item);
    }
    setSortedListingLists([...selected, ...notSelected]);
    setPreAiListings([...aiEnableListings]);
    setTempAiListings([...aiEnableListings]);
    setShowAiListingPopup(true);
  };

  const closeAiListingPopup = (cancelled = false) => {
    setShowAiListingPopup(false);
    if (cancelled) setTempAiListings(preAiListings);
  };

  const handleAiListingCheckboxChange = (event, slug) => {
    const { checked } = event.target;
    setTempAiListings((prev) =>
      checked ? [...new Set([...prev, slug])] : prev.filter((s) => s !== slug)
    );
  };

  const handleAiListingConfirm = () => {
    setAiEnableListings([...tempAiListings]);
    setAiAllListingsSelected(tempAiListings.length === listingLists.length);
    closeAiListingPopup();
  };

  const showKbUpgradeAlert = () => {
    alertModal.confirm({
      title: kbCmsContent?.ai_kb_setup
        ? <span dangerouslySetInnerHTML={{ __html: kbCmsContent.ai_kb_setup }} />
        : <span>Add Your Own Knowledgebase</span>,
      className: 'confirm_modal delete_listing_modal',
      okButtonProps: { style: { display: 'none' } },
      cancelText: 'Maybe Later',
      onOk() {
        // const email = kbSupportEmail || 'support@happyguest.ai';
        // window.location.href = `mailto:${email}`;
      },
      onCancel() {},
    });
  };

  // ✅ Global variable to track last focused textarea and cursor position
  const lastSelectionRef = useRef({ index: null, start: 0, end: 0 });
  // const maxTwilioCharacterLimit = 160;
  const [maxTwilioCharacterLimit, setMaxTwilioCharacterLimit] = useState(160);

  const hoursArray = Array.from({ length: 24 }, (_, index) => {
    let hour = index % 12; // Extract hour from index
    if (hour === 0) hour = 12; // Change 0 to 12
    const period = index < 12 ? 'AM' : 'PM'; // Determine period
    return `${hour.toString().padStart(2, '0')}:00 ${period}`;
  });

  const resetOldStates = () => {
    setPreListingData({});
    setSelectionMode({});
    setCurrentTemplateSlug(null);
    setSelectedListings({});
    setOriginalMessages([]);
    setAdditionalMessages([]);
    setEditingIndex(null);
    setListingLists([]);
    setSortedListingLists([]);
    setChannelList([]);
    setChannelMessages([]);
    setOriginalChannelMessages([]);
    setChannelEditingIndex(null);
  };

  useEffect(() => {
    const getUser = JSON.parse(localStorage.getItem('user'));
    if (getUser) {
      setLoginUser(getUser);
      resetOldStates();
      // Then fetch after state reset is complete (slightly safer)
      // Using microtask queue ensures reset is done before fetching
      Promise.resolve().then(() => {
        fetchSchedulerList();
      });
    }
  }, [hostSlug]);

  useEffect(() => {
    // Only run if we have both template list and listing list
    if (!schedulerTemplateList?.length || !listingLists?.length) return;

    // Generate a list of all slugs once (for "select all" scenario)
    const allSlugs = listingLists.map((listing) => listing.slug);

    // Initialize new default states
    const defaultSelections = {};
    const defaultSelectionMode = {};

    // Loop through each template and determine what should be selected
    schedulerTemplateList.forEach((template) => {
      const templateSlug = template.slug;
      let collectedSlugs = [];
      let allSelected = false;

      // 1️⃣ If user already interacted and `selectedListings` exists
      if (selectedListings && Object.keys(selectedListings).length) {
        const existingSelection = selectedListings[templateSlug] || [];

        if (existingSelection.length) {
          collectedSlugs = existingSelection;
          allSelected = existingSelection.length === listingLists.length;
        }
      }
      // 2️⃣ Else first time opening popup
      else {
        // If DB has saved listing slugs for this template, use them
        if (template.listing_slugs?.length) {
          collectedSlugs = template.listing_slugs;
          allSelected = collectedSlugs.length === listingLists.length;
        }
        // Else select all listings by default
        else {
          collectedSlugs = allSlugs;
          allSelected = true;
        }
      }

      // Store computed selections and selection mode
      defaultSelections[templateSlug] = collectedSlugs;
      defaultSelectionMode[templateSlug] = allSelected;
    });

    // Apply to state (React batches these updates)
    setSelectedListings(defaultSelections);
    setSelectionMode(defaultSelectionMode);
  }, [schedulerTemplateList, listingLists]);

  useEffect(() => {
    if (isListingSelectionPopupOpen) {
      // If model opens of listing then take previous listing data
      // structuredClone() is modern js function which deep copy of data structure so any change in copied object doesn't affect on original object
      setPreListingData({
        selectedListing: structuredClone(selectedListings), // deep copy: Any change in this no affect in original one
        selectionMode: structuredClone(selectionMode),
      });
    }
  }, [isListingSelectionPopupOpen]);

  const fetchSchedulerList = async () => {
    setSpinnerLoader(true);
    try {
      const formData = { host_slug: hostSlug };
      const templateResponse = await dispatch(fetchEmailTemplates(formData));
      if (templateResponse?.status === HttpStatus.HTTP_OK) {
        const templateData = templateResponse?.result || [];
        const otherData = templateResponse?.other_data || [];
        const isSchedulerEnable = otherData?.is_scheduler_enable && otherData?.is_scheduler_enable === 1 ? true : false;
        setIsSexOffededEnable(otherData?.is_sex_offended_enable ?? false);
        if (otherData?.sms_charecter_limit) {
          setMaxTwilioCharacterLimit(otherData.sms_charecter_limit);
        }

        setIsSchedulerEnabled(isSchedulerEnable);

        // Set templates
        setSchedulerTemplateList(templateData);

        // Initialize form values
        const formValues = {};
        templateData.forEach((t, i) => {
          formValues[`note_${i}`] = t.content || '';
          formValues[`sms_content_${i}`] = t.sms_content || '';
          formValues[`email_content_${i}`] = t.email_content || '';
          formValues[`email_subject_${i}`] = t.email_subject || '';
          formValues[`days_${i}`] = t.days;
          formValues[`schedule_time_${i}`] = t.schedule_time;
          formValues[`minutes_${i}`] = t.minutes;
          formValues[`months_${i}`] = t.months;
          formValues[`sms_status_${i}`] = (t.group_id === upsellMarkettingGroupId) ? true : t.is_sms_enable; // Enable for group id upsell marketting.
          formValues[`email_status_${i}`] = (t.group_id === upsellMarkettingGroupId) ? true : t.is_email_enable; // Enable for group id upsell marketting.
        });
        form.setFieldsValue(formValues);

        //  Active slugs
        const initialTemplateSlugs = templateData.filter((item) => item.status_id).map((item) => item.slug);
        setTemplateSlug(initialTemplateSlugs);
        // fetching listings for host
        fetchHostListings();
        fetchChannelList();
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
    } finally {
      fetchCMSCommonFunction(19)
        .then((description) => {
          setMessageCMSMessage(description);
        })
        .catch((error) => {
          console.error('Error fetching CMS message:', error);
        });
    }
    setSpinnerLoader(false);
  };

  const handleMessageEnabledChange = (event) => {
    const isChecked = event.target.checked;
    setIsSchedulerEnabled(isChecked);
  };

  // START: Insert variable at cursor
  const insertVariable = (variable, index) => {
    const currentTab = activeTab[index] ?? channelMessage;

    // Map tab → form field
    const fieldNameMap = {
      [channelMessage]: `note_${index}`,
      [smsMessage]: `sms_content_${index}`,
      [emailMessage]: `email_content_${index}`,
    };

    // Map tab → textarea ref
    const refKeyMap = {
      [channelMessage]: `channel_${index}`,
      [smsMessage]: `sms_${index}`,
      [emailMessage]: `email_${index}`,
    };

    const fieldName = fieldNameMap[currentTab];
    const refKey = refKeyMap[currentTab];

    const textarea = textAreaRefs.current[refKey]?.resizableTextArea?.textArea;
    if (!textarea) return;

    // Save scroll position before update
    const prevScrollTop = textarea.scrollTop;

    const start = textarea.selectionStart || 0;
    const end = textarea.selectionEnd || 0;

    const currentValue = form.getFieldValue(fieldName) || '';

    const newValue = currentValue.slice(0, start) + variable + currentValue.slice(end);

    // Update AntD form
    form.setFieldValue(fieldName, newValue);

    // Keep scheduler list synced (may be used elsewhere)
    setSchedulerTemplateList((prev) => {
      const updated = [...prev];
      const fieldKeyMap = {
        [channelMessage]: 'content',
        [smsMessage]: 'sms_content',
        [emailMessage]: 'email_content',
      };
      updated[index][fieldKeyMap[currentTab] ?? 'content'] = newValue;
      return updated;
    });

    // Run validation
    form.validateFields([fieldName]);

    // Restore cursor and scroll after re-render
    setTimeout(() => {
      textarea.focus();
      textarea.selectionStart = textarea.selectionEnd = start + variable.length;
      textarea.scrollTop = prevScrollTop;
    }, 0);
  };
  // END: Insert variable at cursor

  const handleSchedulerFieldChange = (index, field, value) => {
    setSchedulerTemplateList((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };
      return updated;
    });
  };

  // When user types manually
  const handleNoteChange = (index, value) => {
    form.setFieldValue(`note_${index}`, value);
    setSchedulerTemplateList((prev) => {
      const updated = [...prev];
      updated[index].content = value;
      return updated;
    });
  };

  // When user types manually sms
  const handleSMSChange = (index, value) => {
    form.setFieldValue(`sms_content_${index}`, value);
    setSchedulerTemplateList((prev) => {
      const updated = [...prev];
      updated[index].sms_content = value;
      return updated;
    });
  };

  // When user types manually email
  const handleEmailChange = (index, value) => {
    form.setFieldValue(`email_content_${index}`, value);
    setSchedulerTemplateList((prev) => {
      const updated = [...prev];
      updated[index].email_content = value;
      return updated;
    });
  };

  // When user change email subject
  const handleEmailSubject = (index, value) => {
    form.setFieldValue(`email_subject_${index}`, value);
    setSchedulerTemplateList((prev) => {
      const updated = [...prev];
      updated[index].email_subject = value;
      return updated;
    });
  };

  const handleSubmit = useCallback(async () => {
    try {
      const values = await form.validateFields();

      // Below mention template must have HAPPY_GUEST_LINK.

      const includeTemplates = new Set([
        'booking_confirmation',
        'arrival_instructions',
        'early_checkin',
        'checkout_instructions',
      ]);

      if (isSchedulerEnabled) {
        const hasMissingLink = schedulerTemplateList?.some(
          ({ content = '', sms_content = '', email_content = '', slug } = {}, index) => {
            if (!includeTemplates.has(slug)) return false;

            const isChannelActive = values[`channel_status_${index}`];
            const isSmsActive = values[`sms_status_${index}`];
            const isEmailActive = values[`email_status_${index}`];
            
            if (isChannelActive && !content.includes(placeholderHappyGuestLink)) return true;
            if (isSmsActive && !sms_content.includes(placeholderHappyGuestLink)) return true;
            if (isEmailActive && !email_content.includes(placeholderHappyGuestLink)) return true;

            return false;
          },
        );

        if (hasMissingLink) {
          Notification.addNotificationError(messageCMSMessage?.happyguest_link_message);
          return;
        }
      }

      const errorElements = document.querySelectorAll('.ant-form-item-has-error');
      if (errorElements.length > 0) {
        const firstErrorElement = errorElements[0] ?? 0;
        firstErrorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start',
        });
        return;
      }

      let hasError = false;

      Object.keys(values).forEach((key) => {
        if (key.startsWith('sms_content_')) {
          const index = key.split('_')[2]; // get index
          // no need to check as already disabled upsells marketting. needstoDisable
          if(index >= 12) {
            return ;
          }
          const value = values[key] || '';
          const isActiveSms = values[`sms_status_${index}`];

          if (value.length > maxTwilioCharacterLimit && isActiveSms) {
            smsTwilioValidationIndex.current[index] = true;
            hasError = true;
          }
        }
        if (key.startsWith('email_subject_')) {
          const index = key.split('_')[2]; // get index
          const value = values[key] || '';
          const isActiveEmail = values[`email_status_${index}`];

          if (!value.trim() && isActiveEmail) {
            hasError = true;
          }
        }
      });

      if (hasError) {
        setRefreshComponent((prev) => !prev);
        return;
      }

      const formattedData = {
        host_slug: hostSlug, // Add Host slug
        is_scheduler_enable: isSchedulerEnabled, // Scheduler enable
        ...schedulerTemplateList.reduce((acc, template, index) => {
          // Skip group_id 4 Upsell Marketting
          if (template.group_id === upsellMarkettingGroupId) {
            return acc;
          }
          acc[template.slug] = {
            days: values[`days_${index}`] ?? '',
            content: values[`note_${index}`] ?? '',
            sms_content: values[`sms_content_${index}`] ?? '',
            schedule_time: values[`schedule_time_${index}`] ?? '',
            minutes: values[`minutes_${index}`] ?? '',
            months: values[`months_${index}`] ?? '',
            // template_status: values[`template_status_${index}`] ?? '',
            channel_status: values[`channel_status_${index}`] ?? '',
            sms_status: values[`sms_status_${index}`] ?? '',
            is_all_selected: selectionMode[template.slug] ?? false,
            listing_slugs: selectedListings[template.slug] || [],
            email_content: values[`email_content_${index}`] ?? '',
            email_subject: values[`email_subject_${index}`] ?? '',
            email_status: values[`email_status_${index}`] ?? '',
          };
          return acc;
        }, {}),
      };

      setSpinnerLoader(true);
      try {
        const response = await dispatch(
          updateScheduler(formattedData, (response) => {
            return response;
          }),
        );
        if (response?.status !== HttpStatus.HTTP_OK) {
          if (response?.result?.errorDetail?.length > 0) {
            Notification.addNotificationError(response?.result?.errorDetail[0]?.errorMessage[0]);
          } else {
            Notification.addNotificationError(response.message);
          }
        } else {
          Notification.addNotificationSuccess(response.message);
          onConfigUpdated(true);
          return;
        }
        global.isDirtyGlobal = false;
      } catch (error) {
        console.log('Error in form submission: ', error);
      } finally {
        setSpinnerLoader(false);
      }
    } catch (error) {
      console.error('Validation failed:', error);
    }
  }, [
    form,
    hostSlug,
    isSchedulerEnabled,
    schedulerTemplateList,
    selectionMode,
    selectedListings,
    dispatch,
    resetOldStates,
    fetchSchedulerList,
  ]);

  // START: Listing Additional Varilable Scope
  const fetchHostListings = async () => {
    setSpinnerLoader(true);
    try {
      const formData = { host_slug: hostSlug };
      if (initialSection == 'kb') {
        formData.request_for = 1;
      }
      const listingResponse = await dispatch(fetchHostListing(formData));
      if (listingResponse?.status === HttpStatus.HTTP_OK) {
        const listingData = listingResponse?.result || [];
        // Set Listing Data
        setListingLists(listingData);
        setSortedListingLists(listingData);
        setAdditionalMessages(listingData.map((listing) => listing.additional_message || ''));
        setOriginalMessages(listingData.map((listing) => listing.additional_message || ''));
      }
    } catch (error) {
      console.error('Error fetching Listings:', error);
    }
    setSpinnerLoader(false);
  };

  const openAdditionalMessagePopup = () => {
    setIsVariablePopupOpen(true);
  };

  const closeAdditionalMessagePopup = () => {
    setIsVariablePopupOpen(false);
  };

  const handleEditClick = (index) => {
    setEditingIndex(index);
    // When text field open it sets the value
    form.setFieldsValue({
      [`additional_message_${index}`]: additionalMessages[index] || '',
    });
  };

  const handleCancelClick = (index) => {
    // Revert to original message
    const reverted = [...additionalMessages];
    reverted[index] = originalMessages[index];
    setAdditionalMessages(reverted);

    // Reset form field for that textarea
    form.setFieldsValue({
      [`additional_message_${index}`]: originalMessages[index],
    });
    setEditingIndex(null);
  };

  const handleUpdateClick = async (index) => {
    try {
      setUpdateLoading(true);
      const values = await form.validateFields();
      const updatedMessage = values[`additional_message_${index}`];
      // Only send this single listing's data to API
      const requestData = {
        listing_slug: listingLists[index].slug,
        additional_message: updatedMessage,
        host_slug: hostSlug,
      };
      const updateResponce = await dispatch(
        updateListingAdditionalMessage(requestData, (response) => {
          return response;
        }),
      );
      if (updateResponce?.status === HttpStatus.HTTP_OK) {
        Notification.addNotificationSuccess(updateResponce?.message);
        // update local state
        const updated = [...additionalMessages];
        updated[index] = updatedMessage;
        setAdditionalMessages(updated);
        setOriginalMessages((prevOriginal) => {
          const oldMessage = [...prevOriginal]; // create a shallow copy
          oldMessage[index] = updatedMessage; // replace the element at that index
          return oldMessage; // return the new array
        });
        // fetchSchedulerList();
      } else {
        Notification.addNotificationError(updateResponce.message);
      }
      setEditingIndex(null);
    } catch (err) {
      console.error('Validation failed:', err);
    } finally {
      setUpdateLoading(false); // 🔹 Stop loading
    }
  };

  const handleMessageChange = (index, value) => {
    const updated = [...additionalMessages];
    updated[index] = value;
    setAdditionalMessages(updated);
  };
  // END:Listing Additional Varilable Scope

  // START: Listing Selection for template
  const openListingSelectionPopup = (templateSlug) => {
    // If listingList is not set or found empty then don't allow to open the popup.
    if (!listingLists || listingLists.length === 0) return;
    /* Sorting START: Checked listing will appear topmost. */
    const selectedSlugs = new Set(selectedListings[templateSlug]);
    const selected = [];
    const notSelected = [];
    for (const item of listingLists) {
      (selectedSlugs.has(item.slug) ? selected : notSelected).push(item);
    }
    // If same length found then allow to update listingList state
    const listingListLen = selected.length + notSelected.length === listingLists.length;
    if (listingListLen) {
      setSortedListingLists([...selected, ...notSelected]); // sorted copy for popup display only
    }
    /* Sorting END */
    setCurrentTemplateSlug(templateSlug);
    setIsListingSelectionPopupOpen(true);
  };

  // Closes the listing selection popup
  const closeListingSelectionPopup = (isCancelled = false) => {
    // If user cancels, restore previous selections
    setIsListingSelectionPopupOpen(false);
    if (isCancelled && preListingData) {
      const { selectedListing, selectionMode } = preListingData;
      if (selectedListing && selectionMode) {
        setSelectedListings(selectedListing);
        setSelectionMode(selectionMode);
      }
    } else {
    }
  };

  // On Change while selecting listing for a respective message template
  const handleListingCheckboxChange = (event, listingSlug) => {
    const { checked } = event.target;

    // Use functional update to avoid stale state issues
    setSelectedListings((prevSelected) => {
      const prevGroupList = prevSelected[currentTemplateSlug] || [];

      // Compute the new list depending on checkbox state
      const updatedGroupList = checked
        ? [...new Set([...prevGroupList, listingSlug])] // avoid duplicates
        : prevGroupList.filter((slug) => slug !== listingSlug);

      const newSelected = {
        ...prevSelected,
        [currentTemplateSlug]: updatedGroupList,
      };

      // Also update selection mode based on updated length
      setSelectionMode((prevMode) => ({
        ...prevMode,
        [currentTemplateSlug]: updatedGroupList.length === listingLists.length,
      }));

      return newSelected;
    });
  };

  // Trigger: When user click on update after selecting listing
  const handleListingSelection = () => {
    // If user has selected more than one then only allow to close popup
    if (selectedListings[currentTemplateSlug]?.length) {
      closeListingSelectionPopup();
    } else {
      // otherwise show alert to user
      Notification.addNotificationError(messageCMSMessage?.no_listing_alert_message);
    }
  };

  // For Preview Listing which is common for all sections
  const listingTableColumns = [
    {
      title: 'Listing',
      dataIndex: 'listing_name',
      key: 'listing_name',
    },
  ].filter(Boolean);

  const listingTableData = [];
  sortedListingLists?.map((listingData, index) => {
    const { slug } = listingData;
    const isChecked = selectedListings[currentTemplateSlug]?.includes(listingData.slug);
    return listingTableData.push({
      key: slug,
      listing_name: (
        <div className="user-info">
          <div className="user-info-checkbox">
            <Form.Item
              className="mb-0"
              label={
                <span className="guest-ready-text">
                  <span
                  // onClick={(event) => {
                  //   handleLinkClick(event);
                  // }}
                  ></span>
                </span>
              }
              name="listing_slug"
              labelCol={{ className: 'custom-checkbox-label' }}
            >
              <Checkbox onChange={(e) => handleListingCheckboxChange(e, slug)} checked={isChecked}></Checkbox>
            </Form.Item>
          </div>

          <figure>
            <img className="user-info-image" src={listingData?.listing_image} alt="" />
          </figure>
          <figcaption>
            <Heading className="user-name" as="h6">
              {global.checkPermission('listing-show') ? (
                <Link target="_blank" to={`${backEndPrefix}/listing/detail/${slug}`}>
                  <a className="boldurlLink">{listingData?.listing_name}</a>
                </Link>
              ) : (
                <span>{listingData?.listing_name}</span>
              )}
            </Heading>
            <span className="user-designation" />
            <span>
              <a href={listingData?.checkin_url_link} target="__blank" className="urlLink">
                {listingData?.checkin_url}
              </a>
            </span>
          </figcaption>
        </div>
      ),
    });
  });

  // END: Listing Selection for template

  // Channel Variable Start
  const fetchChannelList = async () => {
    setSpinnerLoader(true);
    try {
      const formData = { host_slug: hostSlug };
      const channelListResponse = await dispatch(fetchChannel(formData));
      if (channelListResponse?.status === HttpStatus.HTTP_OK) {
        const channelData = channelListResponse?.result || [];
        // Set channel Data
        setChannelList(channelData);
        setChannelMessages(channelData.map((channel) => channel.message || ''));
        setOriginalChannelMessages(channelData.map((channel) => channel.message || ''));
      }
    } catch (error) {
      console.error('Error fetching Listings:', error);
    }
    setSpinnerLoader(false);
  };

  const openChannelPopup = () => {
    setIsChannelPopupOpen(true);
  };

  const closeChannelPopup = () => {
    setIsChannelPopupOpen(false);
  };

  const handleChannelEditClick = (index) => {
    setChannelEditingIndex(index);
    // When text field open it sets the value
    channelForm.setFieldsValue({
      [`channel_message_${index}`]: channelMessages[index] || '',
    });
  };

  const handleChannelCancelClick = (index) => {
    // Revert to original message
    const reverted = [...channelMessages];
    reverted[index] = originalChannelMessages[index];
    setChannelMessages(reverted);

    // Reset form field for that textarea
    channelForm.setFieldsValue({
      [`channel_message_${index}`]: originalChannelMessages[index],
    });
    setChannelEditingIndex(null);
  };

  const handleChannelUpdateClick = async (index) => {
    try {
      setUpdateLoading(true);
      const values = await channelForm.validateFields();
      const updatedMessage = values[`channel_message_${index}`];
      // Only send this single listing's data to API
      const requestData = {
        channel_slug: channelList[index].slug,
        channel_message: updatedMessage,
        host_slug: hostSlug,
      };
      const updateResponce = await dispatch(
        updateChannelMessage(requestData, (response) => {
          return response;
        }),
      );
      if (updateResponce?.status === HttpStatus.HTTP_OK) {
        setChannelEditingIndex(null);

        Notification.addNotificationSuccess(updateResponce?.message);
        // update local state
        const updated = [...channelMessages];
        updated[index] = updatedMessage;
        setChannelMessages(updated);
        setOriginalChannelMessages((prevOriginal) => {
          const oldMessage = [...prevOriginal]; // create a shallow copy
          oldMessage[index] = updatedMessage; // replace the element at that index
          return oldMessage; // return the new array
        });
      } else {
        Notification.addNotificationError(updateResponce.message);
        setChannelEditingIndex(null);
      }
    } catch (err) {
      console.error('Validation failed:', err);
    } finally {
      setUpdateLoading(false); // 🔹 Stop loading
    }
  };

  const handleChannelMessageChange = (index, value) => {
    const updated = [...channelMessages];
    updated[index] = value;
    setChannelMessages(updated);
  };
  // Channel Variable end

  const handletab = (index, tab) => {
    setActiveTab((prev) => ({
      ...prev,
      [index]: tab,
    }));
  };

  // Handle Cancel button event
  const handleCancel = (e) => {
    e.preventDefault();
    onConfigUpdated(true);
  };
  const groupedTemplates = schedulerTemplateList?.length
    ? Object.entries(
        schedulerTemplateList.reduce((groups, template, index) => {
          const gid = template.group_id;
          if (!groups[gid]) groups[gid] = [];
          groups[gid].push({ template, index });
          return groups;
        }, {}),
      )
    : [['default', []]];

  // Upsells Marketing info text
  const handleHelpPleasePopup = (event) => {
    event.preventDefault();
    const hasIntercomArticleId = Functions.findIntercomArticleId(messageCMSMessage?.upsell_help_text); // Check if CMS content has an Intercom ID
    if (!hasIntercomArticleId) {
      setCmsContent(messageCMSMessage?.upsell_help_text);
      setShowCmsPopupInfo(true);
    }
  };

  const closeCMSPopupInfo = () => {
    setShowCmsPopupInfo(false);
  };

  const handleSwitchChange = (index, fieldPrefix, slug, tab) => (checked) => {
      // Manage tab switch
      handletab(index, tab)
      const isBlocked = slug === "sex_offender_approved" && !isSexOffededEnable;

      const fieldName = `${fieldPrefix}_${index}`;
      if (isBlocked && checked) {
        setCmsContent(messageCMSMessage?.sex_offended_note);
        setShowCmsPopupInfo(true);

        // revert value immediately
        form.setFieldsValue({
          [fieldName]: false,
        });

        return;
      }

      form.setFieldsValue({
        [fieldName]: checked,
      });
  };

  return (
    <>
      {activeSection === 'kb' && (loginUser.role_id === hostLoginRoleID || loginUser.role_id === adminLoginRoleID) ? (
        <>
          <Cards xs={24} headless className="borderRadius common_fiter_table">
            <Main className="mainBlock messages-setting-module">
              <div className="custom-tab-wrapper">
                <div
                  className={`custom-pill ${activeSection === 'messages' ? 'active' : ''}`}
                  onClick={() => handleSectionChange('messages')}
                >
                  Scheduled Messages
                </div>
                <div
                  className={`custom-pill ${activeSection === 'kb' ? 'active' : ''}`}
                  onClick={() => handleSectionChange('kb')}
                >
                  AI Chat
                </div>
              </div>
              <Divider className="mt-20 mb-19" />
              <Col xs={24} sm={24} md={24} lg={16} xl={24} xxl={16} className="pl-0 pr-0">
                {loginUser.role_id === adminLoginRoleID && (
                  <div className="kb-admin-options-section">
                    <div className="kb-section-row d-flex align-items-center justify-content-between">
                      <div className="kb-toggle-label-row d-flex align-items-center">
                        <Switch size="large" className="switch-toggle" checked={isAiChatEnabled} onChange={(val) => setIsAiChatEnabled(val)} />
                        <span className="project-detail-lable">Activate AI Chat</span>
                      </div>
                      <div className="color-dark use-this-text select_listing_right">
                        <a
                          className="common_urlLink font-14-700"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            openAiListingPopup();
                          }}
                        >
                          Select Listings
                        </a>
                      </div>
                    </div>
                    <div className="kb-section-row mt-10">
                      <div className="kb-toggle-label-row d-flex align-items-center">
                        <Switch size="large" className="switch-toggle" checked={isKbEnabled} onChange={(val) => setIsKbEnabled(val)} />
                        <span className="project-detail-lable">Allow Host to setup &amp; Configure own knowledgebase</span>
                      </div>
                    </div>
                  </div>
                )}
                {loginUser.role_id === hostLoginRoleID && (
                  <div className="kb-host-knowledge-section">
                    <div className="kb-section-row d-flex align-items-center justify-content-between">
                      <div className="kb-toggle-label-row d-flex align-items-center">
                        <Switch size="large" className="switch-toggle" checked={isAiChatEnabled} onChange={(val) => setIsAiChatEnabled(val)} />
                        <span className="project-detail-lable">Activate AI Chat</span>
                      </div>
                      <div className="color-dark use-this-text select_listing_right">
                        <a
                          className="common_urlLink font-14-700"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            openAiListingPopup();
                          }}
                        >
                          Select Listings
                        </a>
                      </div>
                    </div>
                    {!isKbEnabled && (
                      <div className="kb-section-row d-flex align-items-center justify-content-between">
                        <span className="project-detail-lable font-weight-bold">Host Knowledge</span>
                        <Button
                          size="default"
                          type="primary"
                          shape="circle"
                          className="update-btn"
                          onClick={() => showKbUpgradeAlert()}
                        >
                          Add Own Knowledge Base
                        </Button>
                      </div>
                    )}
                    {isKbEnabled && (
                      <div className="kb-section-row d-flex align-items-center justify-content-between">
                        <span className="project-detail-lable font-weight-bold">Learn from Conversations</span>
                        <Button
                          size="default"
                          type="primary"
                          shape="circle"
                          className="update-btn"
                          onClick={() => setLearnModalVisible(true)}
                        >
                          Learn from Past Conversations (Last 3 Months)
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </Col>
              <Col xs={24} sm={24} md={24} lg={16} xl={24} xxl={16} className="pl-0 pr-0">
                <KBDefaultsViewer
                  contentType={4}
                  sectionTitle="HAPPY GUEST DEFAULTS - COMMON GUEST QUESTIONS"
                  cmsDefaultsText={kbCmsContent?.ai_common_que_text}
                  cmsDefaultGroupsText={
                    loginUser.role_id === adminLoginRoleID
                      ? kbCmsContent?.ai_common_que_text
                      : kbCmsContent?.ai_kb_settings_host
                  }
                  showToggle={savedIsAiChatEnabled}
                  isEditMode
                />
                <>
                  {/* <Divider className="mt-20 mb-19" /> */}
                  <Heading as="h3">
                    <span className="text-uppercase">YOUR KNOWLEDGEBASE</span>
                  </Heading>
                  {kbCmsContent?.ai_kb_settings_host && (
                    <p className="project-detail-lable mb-10" dangerouslySetInnerHTML={{ __html: kbCmsContent.ai_kb_settings_host }} />
                  )}
                  <KBGroupManager
                    contentType={4}
                    readOnly={loginUser.role_id === hostLoginRoleID ? !isKbEnabled : false}
                    allowFileUpload
                    isAiChatEnabled={savedIsAiChatEnabled}
                    isKbEnabled={loginUser.role_id === adminLoginRoleID ? savedIsKbEnabled : true}
                  />
                </>
              </Col>
            </Main>
          </Cards>
          <div className="manage-listing-btn">
            <Button
              htmlType="button"
              size="default"
              shape="circle"
              type="primary"
              className="update-btn"
              disabled={isKbSaving}
              onClick={handleKbSave}
              key="saveKbBtn"
            >
              {isKbSaving ? 'Loading...' : 'Save'}
            </Button>
            <Button
              onClick={(e) => handleCancel(e)}
              shape="circle"
              className="form-cancel-btn"
              outlined
              type="primary"
              key="cancelKbBtn"
              disabled={isKbSaving}
            >
              Cancel
            </Button>
          </div>
        </>
      ) : (
      <>
      {spinnerLoader && (
        <Cards xs={24} headless className="borderRadius common_fiter_table">
          <Main className="mainBlock messages-setting-module">
            {(loginUser.role_id === hostLoginRoleID || loginUser.role_id === adminLoginRoleID) && (
              <div className="custom-tab-wrapper">
                <div className={`custom-pill ${activeSection === 'messages' ? 'active' : ''}`} onClick={() => handleSectionChange('messages')}>Scheduled Messages</div>
                <div className={`custom-pill ${activeSection === 'kb' ? 'active' : ''}`} onClick={() => handleSectionChange('kb')}>AI Chat</div>
              </div>
            )}
            <Spinner loader={true} />
          </Main>
        </Cards>
      )}
      <Form form={form} layout="">
        <AddUser>
          <BasicFormWrapper>
            <>
              {!spinnerLoader && groupedTemplates.map(([groupId, items], groupIndex) => (
                <Cards
                  key={groupId}
                  xs={24}
                  headless
                  className={`borderRadius common_fiter_table ${
                    groupId != 1 && isSchedulerEnabled ? 'border-radius-main borderRadius-24' : ''
                  } `}
                >
                  <Main className="mainBlock messages-setting-module" style={{ paddingBottom: '0px' }}>
                    {groupIndex === 0 && (loginUser.role_id === hostLoginRoleID || loginUser.role_id === adminLoginRoleID) && (
                      <>
                        <div className="custom-tab-wrapper">
                          <div
                            className={`custom-pill ${activeSection === 'messages' ? 'active' : ''}`}
                            onClick={() => handleSectionChange('messages')}
                          >
                            Scheduled Messages
                          </div>
                          <div
                            className={`custom-pill ${activeSection === 'kb' ? 'active' : ''}`}
                            onClick={() => handleSectionChange('kb')}
                          >
                            AI Chat
                          </div>
                        </div>
                        <Divider className="mt-20 mb-19" />
                      </>
                    )}
                    {/* FIRST CARD */}
                    {/* {groupIndex === 0 && loginUser.role_id === adminLoginRoleID && (
                      <>
                        <Row gutter={15}>
                          <Col xs={24} md={24}>
                            <div className="project-modal">
                              <Form.Item
                                className="checkbox-title-inline"
                                label="Turn on Automated Messages"
                                labelCol={{ className: 'custom-checkbox-label' }}
                              >
                                <Checkbox
                                  className="cus-checkbox-inline"
                                  checked={isSchedulerEnabled}
                                  onChange={handleMessageEnabledChange}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                        <Divider />
                      </>
                    )} */}

                    {/* SHOW TEMPLATES ONLY WHEN ENABLED */}
                    {isSchedulerEnabled && items.length > 0 ? (
                      <>
                        <Row gutter={15} className="project-modal">
                          <Heading as="h3">
                            <span className="text-uppercase pl-5">{items[0].template.group_name}</span>
                          </Heading>
                        </Row>
                        <Row gutter={15} className="project-modal">
                          <Col
                            xs={24}
                            sm={24}
                            md={24}
                            lg={16} // normal laptop
                            xl={24} // 1280px
                            xxl={16} // 1905px
                          >
                            {/* Upsells Marking Info Text */}
                            {groupId == upsellMarkettingGroupId && (
                              <span>
                                Automated Early Check-In Availability (if marked ready more than an hour before check-in
                                time){' '}
                                (🛎️
                                <a className="common_urlLink" onClick={(event) => handleHelpPleasePopup(event)}>
                                  Help please!
                                </a>
                                ): <br />
                                - For same-day check-ins, guests receive this message about 3 minutes after marking
                                guest ready <br />- For non-same-day check-ins, the next guest will receive this message
                                at 9am on their check-in date
                              </span>
                            )}
                          </Col>
                        </Row>

                        {items.map(({ template: schedulerTemplate, index }) => {
                          const { config, title, group_name, group_id, slug } = schedulerTemplate || {};
                          const { days, time, minutes, months } = config || {};
                          const colEqualDivision = days?.is_display && time?.is_display && minutes?.is_display ? 8 : 12;
                          const showHeader = index === 0 || schedulerTemplateList[index - 1]?.group_id !== group_id;
                          const [mainTitle, ...restTitle] = title?.split(':') || [];
                          let subTitle = restTitle.length ? restTitle.join(':').trim() : null;
                          if (months?.is_display && subTitle) {
                            const monthsVariable = Number(form.getFieldValue(`months_${index}`) ?? 0);
                            if (monthsVariable > 0) {
                              subTitle = subTitle.replace(/\bX\b(?=\s+months?\b)/i, monthsVariable);
                            }
                          }
                          const smsStatus = form.getFieldValue(`sms_status_${index}`) ?? false;
                          const emailStatus = form.getFieldValue(`email_status_${index}`) ?? false;
                          const channelStatus = form.getFieldValue(`channel_status_${index}`) ?? false;
                          const needsToDisable = group_id === upsellMarkettingGroupId; // Upsell Messaging
                          return (
                            <React.Fragment key={index}>
                              <Col
                                xs={24}
                                sm={24}
                                md={24}
                                lg={16} // normal laptop
                                xl={24} // 1280px
                                xxl={16} // 1905px
                              >
                                <div className="scheduler-row-inline">
                                  {title && (<span className="scheduler-title-group">
                                    <strong className="scheduler-main-title color-dark">
                                      {!needsToDisable ? `#${index + 1} ${mainTitle}` : mainTitle}
                                    </strong>
                                    {subTitle && (<span className="scheduler-sub-title text-muted-small">: {subTitle} </span>
                                    )}
                                  </span>
                                  )}

                                  {!needsToDisable && (
                                    <>
                                      {days?.is_display && (
                                        <>
                                            <Form.Item
                                              name={`days_${index}`}
                                              className="scheduler-form-inline early_check_input"
                                              rules={[
                                                {
                                                  required: false,
                                                  message: `Please enter ${days?.label || 'days'}`,
                                                },
                                                {
                                                  type: 'number',
                                                  transform: (value) => Number(value),
                                                  min: 0,
                                                  max: 30,
                                                  message: 'Days must be between 0 and 30',
                                                },
                                              ]}
                                            >
                                              <InputNumber
                                                prefix={''}
                                                placeholder={days?.label}
                                                tabIndex={2}
                                                min={0}
                                                max={30}
                                                onChange={(value) => handleSchedulerFieldChange(index, 'days', value)}
                                              />
                                          </Form.Item>
                                          <span className="scheduler-text">{days?.label} </span>
                                        </>
                                      )}
                                      {time?.is_display && (
                                        <>
                                            <Form.Item
                                              name={`schedule_time_${index}`}
                                              className="custom_input_style scheduler-form-inline">
                                              <Select
                                                size="large"
                                                className="ninjadash-fullwidth-select"
                                                placeholder={time?.label}
                                                allowClear
                                                onChange={(value) =>
                                                  handleSchedulerFieldChange(index, 'schedule_time', value)
                                                }
                                              >
                                                {hoursArray.map((value) => (
                                                  <Select.Option key={value} value={value}>
                                                    {value}
                                                  </Select.Option>
                                                ))}
                                              </Select>
                                            </Form.Item>
                                          <span className="scheduler-text">{time?.label} </span>
                                        </>
                                      )}
                                      {minutes?.is_display && (
                                        <>
                                            <Form.Item
                                              name={`minutes_${index}`}
                                              className="scheduler-form-inline early_check_input"
                                              rules={[
                                                {
                                                  required: false,
                                                  message: `Please enter ${minutes?.label || 'minutes'}`,
                                                },
                                                {
                                                  type: 'number',
                                                  transform: (value) => Number(value),
                                                  min: 0,
                                                  max: 59,
                                                  message: `${minutes?.label || 'minutes'} must be between 0 and 59`,
                                                },
                                              ]}
                                            >
                                              <InputNumber
                                                prefix={''}
                                                placeholder={minutes?.label}
                                                tabIndex={2}
                                                min={0}
                                                max={59}
                                                onChange={(value) =>
                                                  handleSchedulerFieldChange(index, 'minutes', value)
                                                }
                                              />
                                              </Form.Item>
                                          <span className="scheduler-text">{minutes?.label} </span>
                                        </>
                                      )}
                                      {months?.is_display && (
                                        <>
                                            <Form.Item
                                              name={`months_${index}`} 
                                              className="scheduler-form-inline early_check_input"
                                              rules={[
                                                {
                                                  required: false,
                                                  message: `Please enter ${months?.label || 'months'}`,
                                                },
                                                {
                                                  type: 'number',
                                                  transform: (value) => Number(value),
                                                  min: 1,
                                                  max: 12,
                                                  message: `Please enter a value for months after between 1 and 12.`,
                                                },
                                              ]}
                                            >
                                              <InputNumber
                                                prefix={''}
                                                placeholder={months?.label}
                                                tabIndex={2}
                                                min={1}
                                                max={12}
                                                onChange={(value) => handleSchedulerFieldChange(index, 'months', value)}
                                              />
                                              </Form.Item>
                                          <span className="scheduler-text">{months?.label} </span>
                                        </>
                                      )}
                                    </>
                                  )}


                                <Row gutter={15} key={index}>
                                  <Col xl={24} xs={24} className="pl-0 pr-0">
                                    <div className="custom-tabs-wrapper project-modal">
                                      <div className="custom-tabs">
                                        {/* Hide Channel Tab for Upsell Marketting */}
                                        {!needsToDisable && (
                                          <div
                                            className={`custom-tab ${
                                              (activeTab[index] ?? channelMessage) === channelMessage ? 'active' : ''
                                            }`}
                                            onClick={() => handletab(index, channelMessage)}
                                          >
                                            <Form.Item
                                              name={`channel_status_${index}`}
                                              valuePropName="checked"
                                              initialValue={schedulerTemplate.is_channel_enable}
                                              className="template-switch-item"
                                            >
                                              <Switch
                                                size="large"
                                                className="switch-toggle"
                                                disabled={needsToDisable}
                                                onChange={handleSwitchChange(index, "channel_status", slug, channelMessage)}
                                              />
                                            </Form.Item>
                                            Channel
                                          </div>
                                        )}

                                        <div
                                          className={`custom-tab ${
                                            (activeTab[index] ?? (needsToDisable ? smsMessage : channelMessage)) ===
                                            smsMessage
                                              ? 'active'
                                              : ''
                                          }`}
                                          onClick={() => handletab(index, smsMessage)}
                                        >
                                          <Form.Item
                                            name={`sms_status_${index}`}
                                            valuePropName="checked"
                                            initialValue={schedulerTemplate.is_sms_enable}
                                            className="template-switch-item"
                                          >
                                            <Switch size="large" className="switch-toggle" disabled={needsToDisable} onChange={handleSwitchChange(index, "sms_status", slug, smsMessage)} />
                                          </Form.Item>
                                          SMS
                                        </div>
                                        {/* Email Template only visible to Upsell Marketting */}
                                          <div
                                            className={`custom-tab ${
                                              (activeTab[index] ?? channelMessage) === emailMessage ? 'active' : ''
                                            }`}
                                            onClick={() => handletab(index, emailMessage)}
                                          >
                                            <Form.Item
                                              name={`email_status_${index}`}
                                              valuePropName="checked"
                                              initialValue={schedulerTemplate.is_email_enable}
                                              className="template-switch-item"
                                            >
                                              <Switch
                                                size="large"
                                                className="switch-toggle"
                                                disabled={needsToDisable}
                                                onChange={handleSwitchChange(index, "email_status", slug, emailMessage)}
                                              />
                                            </Form.Item>
                                            Email
                                          </div>
                                        <div className="color-dark use-this-text select_listing_right">
                                          {!needsToDisable && schedulerTemplate?.listing?.total_listings > 0 && (
                                            <>
                                              <a
                                                className="common_urlLink font-14-700"
                                                href="#"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  openListingSelectionPopup(schedulerTemplate?.slug);
                                                }}
                                              >
                                                Select Listings
                                              </a>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </Col>

                                  <Col xs={24} className={`pl-0 pr-0 ${(activeTab[index] ?? channelMessage) === emailMessage ? 'd-block' : 'd-none'}`}>
                                      <div className="project-modal provider_bodyvariable_box">
                                        <Form.Item
                                          className="email_subject_field_name"
                                          name={`email_subject_${index}`}
                                          rules={[
                                            {
                                              required: emailStatus,
                                              message: 'Please enter email subject',
                                            },
                                          ]}
                                        >
                                          <Input
                                            onChange={(e) => handleEmailSubject(index, e.target.value)}
                                            placeholder="Enter email subject"
                                            className="h-50"
                                            disabled={needsToDisable}
                                          />
                                        </Form.Item>
                                      </div>
                                    </Col>
                                  {/* Variable List */}
                                  {!needsToDisable && (
                                    <Col xs={24} className="pl-0 pr-0">
                                      <div className="project-modal message-variable-list">
                                        <ul>
                                          <li className="variable-btn-wrapper">
                                            <a
                                              className=" listing_variable_btn"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                insertVariable('[GUEST_FIRST_NAME]', index);
                                              }}
                                            >
                                              GUEST FIRST NAME 👋
                                            </a>{' '}
                                            <a
                                              className="listing_variable_btn"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                insertVariable('[DATE_OF_ARRIVAL]', index);
                                              }}
                                            >
                                              DATE OF ARRIVAL 📅
                                            </a>{' '}
                                            <a
                                              className="listing_variable_btn"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                insertVariable('[CHECKIN_TIME]', index);
                                              }}
                                            >
                                              CHECK IN TIME 🕒
                                            </a>{' '}
                                            <a
                                              className="listing_variable_btn"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                insertVariable('[DATE_OF_DEPARTURE]', index);
                                              }}
                                            >
                                              DATE OF DEPARTURE 📅
                                            </a>{' '}
                                            <a
                                              className="listing_variable_btn"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                insertVariable('[CHECKOUT_TIME]', index);
                                              }}
                                            >
                                              CHECK OUT TIME 🕒
                                            </a>{' '}
                                            <a
                                              className="listing_variable_btn"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                insertVariable('[HAPPY_GUEST_LINK]', index);
                                              }}
                                            >
                                              HAPPY GUEST LINK 🔗
                                            </a>{' '}
                                            <a
                                              className="listing_variable_btn"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                insertVariable('[HOST_DISPLAY_NAME]', index);
                                              }}
                                            >
                                              HOST DISPLAY NAME 👋
                                            </a>{' '}
                                            <a
                                              className="listing_variable_btn mr-0"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                insertVariable('[LISTING_VARIABLE]', index);
                                              }}
                                            >
                                              LISTING VARIABLE 🏠
                                            </a>
                                            <a
                                              className="edit-icon listing_variable_btn"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                openAdditionalMessagePopup();
                                              }}
                                            >
                                              <img src={cmsIcon} alt="Edit Icon" />
                                            </a>
                                            <a
                                              className="listing_variable_btn mr-0"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                insertVariable('[CHANNEL_VARIABLE]', index);
                                              }}
                                            >
                                              CHANNEL VARIABLE 🏢
                                            </a>
                                            <a
                                              className="edit-icon listing_variable_btn"
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                openChannelPopup();
                                              }}
                                            >
                                              <img src={cmsIcon} alt="Edit Icon Channel" />
                                            </a>
                                            {(activeTab[index] ?? channelMessage) === channelMessage && (
                                              <>
                                                {/* <a
                                                  className="listing_variable_btn"
                                                  href="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    insertVariable('[ARRIVAL_INSTRUCTION]', index);
                                                  }}
                                                >
                                                  ARRIVAL INSTRUCTION ℹ️
                                                </a> */}
                                                <a
                                                  className="listing_variable_btn"
                                                  href="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    insertVariable('[HOUSE_MANUAL]', index);
                                                  }}
                                                >
                                                  HOUSE MANUAL 📘
                                                </a>
                                              </>
                                            )}
                                          </li>
                                        </ul>
                                      </div>
                                    </Col>
                                  )}
                                  {/* CHANNEL MESSAGE */}
                                  {!needsToDisable && (
                                    <Col
                                      xs={24}
                                      className={`pl-0 pr-0 ${
                                        (activeTab[index] ?? channelMessage) === channelMessage ? 'd-block' : 'd-none'
                                      }`}
                                    >
                                      <div className="project-modal provider_bodyvariable_box message-variable-textarea">
                                        <Form.Item
                                          // label="Notes"
                                          name={`note_${index}`}
                                          rules={[
                                            {
                                              required: channelStatus,
                                              message: 'Channel message is required.',
                                              transform: (value) => value?.trim(),
                                            },
                                          ]}
                                        >
                                          <Input.TextArea
                                            ref={(el) => (textAreaRefs.current[`channel_${index}`] = el)}
                                            placeholder="Type your message to the guest here."
                                            rows={5}
                                            id={`template_content_${index}`}
                                            onChange={(e) => handleNoteChange(index, e.target.value)}
                                            disabled={needsToDisable}
                                          />
                                        </Form.Item>
                                      </div>
                                    </Col>
                                  )}
                                  {/* SMS MESSAGE */}
                                  <Col
                                    xs={24}
                                    className={`pl-0 pr-0 ${
                                      (activeTab[index] ?? (needsToDisable ? smsMessage : channelMessage)) ===
                                      smsMessage
                                        ? 'd-block'
                                        : 'd-none'
                                    }`}
                                  >
                                    <div className="project-modal provider_bodyvariable_box message-variable-textarea">
                                      <Form.Item
                                        // label="Notes"
                                        name={`sms_content_${index}`}
                                        rules={[
                                          {
                                            required: smsStatus,
                                            message: 'SMS content is required.',
                                          },
                                          {
                                            validator: (_, value) => {
                                              if (!value) return Promise.resolve();
                                              // Twilio GSM-7 or Unicode check
                                              if (value.length > maxTwilioCharacterLimit) {
                                                smsTwilioValidationIndex.current[index] = true;
                                              } else {
                                                smsTwilioValidationIndex.current[index] = false;
                                              }
                                              return Promise.resolve();
                                            },
                                          },
                                        ]}
                                      >
                                        <Input.TextArea
                                          ref={(el) => (textAreaRefs.current[`sms_${index}`] = el)}
                                          placeholder="Short SMS message for the guest."
                                          rows={5}
                                          id={`template_content_sms_${index}`}
                                          onChange={(e) => handleSMSChange(index, e.target.value)}
                                          disabled={needsToDisable}
                                        />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                  {/* EMAIL MESSAGE */}
                                  <Col
                                    xs={24}
                                    className={`pl-0 pr-0 ${activeTab[index] === emailMessage ? 'd-block' : 'd-none'}`}
                                  >
                                    <div className="project-modal provider_bodyvariable_box message-variable-textarea">
                                      <Form.Item
                                        // label="Notes"
                                        name={`email_content_${index}`}
                                        rules={[
                                          {
                                            required: emailStatus && !needsToDisable, // Default enable for upsell marketing getting error so it adds here if goupid 4 then it will not required
                                            message: 'Email content is required.',
                                          },
                                        ]}
                                      >
                                        <Input.TextArea
                                          ref={(el) => (textAreaRefs.current[`email_${index}`] = el)}
                                          placeholder="Write a detailed email for the guest."
                                          rows={5}
                                          id={`template_content_email_${index}`}
                                          onChange={(e) => handleEmailChange(index, e.target.value)}
                                          disabled={needsToDisable}
                                        />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                  {/* If SMS Enable and length of sms more than twilio limit */}
                                  {/* For disabled group id upsell marketing bypassing the validation. */}
                                  {smsStatus && smsTwilioValidationIndex.current[index] && !needsToDisable && (
                                    <div className="showImageError">
                                      <div class="ant-form-item-has-error ant-form-item-explain-error">
                                        SMS limit should be less than {maxTwilioCharacterLimit} character
                                      </div>
                                    </div>
                                  )}
                                </Row>
                                <Divider />
                                </div>
                              </Col>
                            </React.Fragment>
                          );
                        })}
                      </>
                    ) : loginUser.role_id === hostLoginRoleID ? (
                      <>
                        <span
                          className="custom_editor_span_text"
                          dangerouslySetInnerHTML={{ __html: messageCMSMessage?.automated_setting_message }}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </Main>
                </Cards>
              ))}
              {!spinnerLoader && groupedTemplates?.length > 0 && !isSchedulerEnabled && loginUser.role_id === hostLoginRoleID && (
                <Cards xs={24} headless className="borderRadius common_fiter_table">
                  <span>&emsp;</span>
                </Cards>
              )}
            </>
          </BasicFormWrapper>
        </AddUser>
        <div className="manage-listing-btn">
          {loginUser.role_id === hostLoginRoleID && isSchedulerEnabled && (
            <>
              <Button
                htmlType="submit"
                size="default"
                shape="circle"
                type="primary"
                key="submit"
                onClick={handleSubmit}
                className="update-btn"
              >
                Save
              </Button>
            </>
          )}
          {loginUser.role_id === adminLoginRoleID && (
            <>
              <Button
                htmlType="submit"
                size="default"
                shape="circle"
                type="primary"
                key="submit"
                onClick={handleSubmit}
                className="update-btn"
              >
                Save
              </Button>
            </>
          )}
          <Button
            onClick={(e) => handleCancel(e)}
            shape="circle"
            className="form-cancel-btn"
            outlined
            type="primary"
            key={'cancelBtn'}
          >
            Cancel
          </Button>
        </div>
      </Form>
      </>
      )}
      <LearnFromConversations
        visible={learnModalVisible}
        onClose={() => setLearnModalVisible(false)}
        onAdded={() => setLearnModalVisible(false)}
      />

      {/* AI Chat Listing Selection Modal */}
      <Modal
        type="primary"
        open={showAiListingPopup}
        footer={null}
        onCancel={() => closeAiListingPopup(true)}
        width="90%"
        maskClosable={false}
        aria-hidden="false"
        className="bulk-listing-modal template-config-listing-modal"
        title={`Select Listings (${tempAiListings.length}/${listingLists?.length || 0})`}
      >
        <div className="guide-matching-listing">
          <div className="project-modal">
            <div className="guide-card">
              <div className="guide-card-body">
                <UserTableStyleWrapper>
                  <div className="contact-table">
                    <TableWrapper className="table-responsive">
                      <Table
                        dataSource={sortedListingLists.map((item) => ({
                          key: item.slug,
                          listing_name: (
                            <div className="user-info">
                              <div className="user-info-checkbox">
                                <Form.Item className="mb-0" name={`ai_listing_${item.slug}`} labelCol={{ className: 'custom-checkbox-label' }}>
                                  <Checkbox
                                    checked={tempAiListings.includes(item.slug)}
                                    onChange={(e) => handleAiListingCheckboxChange(e, item.slug)}
                                  />
                                </Form.Item>
                              </div>
                              <figure>
                                <img className="user-info-image" src={item?.listing_image} alt="" />
                              </figure>
                              <figcaption>
                                <Heading className="user-name" as="h6">
                                  {global.checkPermission('listing-show') ? (
                                    <Link target="_blank" to={`${backEndPrefix}/listing/detail/${item.slug}`}>
                                      <a className="boldurlLink">{item?.listing_name}</a>
                                    </Link>
                                  ) : (
                                    <span>{item?.listing_name}</span>
                                  )}
                                </Heading>
                                <span className="user-designation" />
                              </figcaption>
                            </div>
                          ),
                        }))}
                        columns={[{ title: 'Listing', dataIndex: 'listing_name', key: 'listing_name' }]}
                        rowKey="key"
                        pagination={false}
                        className="listing-no-thead-table"
                      />
                    </TableWrapper>
                  </div>
                </UserTableStyleWrapper>
              </div>
              <div className="bulk-editbtn-box">
                <Button htmlType="submit" size="default" type="dark" shape="circle" key="submit" onClick={handleAiListingConfirm}>
                  Update
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* Listing Selection for Templates */}
      <Modal
        type="primary"
        open={isListingSelectionPopupOpen}
        footer={null}
        onCancel={() => closeListingSelectionPopup(true)}
        width={'90%'}
        maskClosable={false}
        key={2}
        aria-hidden="false"
        className="bulk-listing-modal template-config-listing-modal"
        title={`Selected Listings (${selectedListings[currentTemplateSlug]?.length}/${listingLists?.length})`}
      >
        {/* Bulk edit behaviour */}
        <>
          <div className="guide-matching-listing">
            <div className="project-modal">
              <div class="guide-card">
                <div className="guide-card-body">
                  <UserTableStyleWrapper>
                    <div className="contact-table">
                      <TableWrapper className="table-responsive">
                        <Table
                          dataSource={listingTableData}
                          columns={listingTableColumns}
                          rowKey="slug"
                          pagination={false}
                          className={`listing-no-thead-table`}
                        />
                      </TableWrapper>
                    </div>
                  </UserTableStyleWrapper>
                </div>
                <div className="bulk-editbtn-box">
                  <Button
                    htmlType="submit"
                    size="default"
                    type="dark"
                    shape="circle"
                    key="submit"
                    className=""
                    onClick={() => handleListingSelection()}
                  >
                    Update
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      </Modal>

      {/* Listing Additional Varilable */}
      <Modal
        type="primary"
        open={isVariablePopupOpen}
        footer={null}
        onCancel={closeAdditionalMessagePopup}
        // width={'60%'}
        maskClosable={false}
        key={2}
        aria-hidden="false"
        centered
      >
        <div className="Idmodalbox earlyCheckinPopup special-listing-variable">
          <div className="hostPayout">
            <h3>Special Variable for the Listings</h3>
          </div>
          <Form form={form}>
            {listingLists.map((listing, index) => (
              <div className="special-list-box" key={listing.slug ? `varilable_${listing.slug}` : `varilable_${index}`}>
                <Row gutter={15} className="align-items-center">
                  <Col xs={12} md={12}>
                    <div className="project-modal">
                      <span className="listing-title">{listing?.listing_name}</span>
                    </div>
                  </Col>
                  <Col xs={12} md={12} className="text-right">
                    <div className="project-modal">
                      {editingIndex === index ? (
                        <>
                          <Button
                            type="primary"
                            shape="circle"
                            className="update-primary-btn"
                            onClick={() => handleUpdateClick(index)}
                            disabled={updateLoading} // disable while loading
                          >
                            {updateLoading ? 'Updating...' : 'Update'}
                          </Button>
                          <Button
                            className="cancel-default-btn"
                            shape="circle"
                            onClick={() => handleCancelClick(index)}
                          >
                            Cancel
                          </Button>
                        </>
                      ) : (
                        <Button
                          type="primary"
                          className="edit-btn-icon"
                          shape="circle"
                          onClick={() => handleEditClick(index)}
                        >
                          <img src={cmsIcon} alt="Edit Icon" />
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row gutter={15}>
                  <Col xs={24}>
                    <div className="project-modal provider_bodyvariable_box">
                      {editingIndex === index ? (
                        <Form.Item
                          name={`additional_message_${index}`}
                          // initialValue={additionalMessages[index]}
                          /*rules={[
                            {
                              required: true,
                              message: 'Please enter additional listing message',
                            },
                          ]}*/
                        >
                          <Input.TextArea
                            placeholder="Enter additional listing message"
                            rows={5}
                            // value={additionalMessages[index]}
                            // onChange={(e) => handleMessageChange(index, e.target.value)}
                          />
                        </Form.Item>
                      ) : (
                        <p>{additionalMessages[index] || ''}</p>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
          </Form>
        </div>
      </Modal>

      {/* Channel Message */}
      <Modal
        type="primary"
        open={isChannelPopupOpen}
        footer={null}
        onCancel={closeChannelPopup}
        // width={'60%'}
        maskClosable={false}
        key={2}
        aria-hidden="false"
      >
        <div className="Idmodalbox earlyCheckinPopup special-listing-variable">
          <div className="hostPayout">
            <h3>Special Variable for Channels</h3>
          </div>
          <Form form={channelForm}>
            {channelList.map((channel, index) => (
              <div className="special-list-box" key={channel.slug ? `varilable_${channel.slug}` : `varilable_${index}`}>
                <Row gutter={15} className="align-items-center">
                  <Col xs={12} md={12}>
                    <div className="project-modal">
                      <span className="listing-title">{channel?.name}</span>
                    </div>
                  </Col>
                  <Col xs={12} md={12} className="text-right">
                    <div className="project-modal">
                      {channelEditingIndex === index ? (
                        <>
                          <Button
                            type="primary"
                            shape="circle"
                            className="update-primary-btn"
                            onClick={() => handleChannelUpdateClick(index)}
                            disabled={updateLoading} // disable while loading
                          >
                            {updateLoading ? 'Updating...' : 'Update'}
                          </Button>
                          <Button
                            className="cancel-default-btn"
                            shape="circle"
                            onClick={() => handleChannelCancelClick(index)}
                          >
                            Cancel
                          </Button>
                        </>
                      ) : (
                        <Button
                          type="primary"
                          className="edit-btn-icon"
                          shape="circle"
                          onClick={() => handleChannelEditClick(index)}
                        >
                          <img src={cmsIcon} alt="Edit Icon" />
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row gutter={15}>
                  <Col xs={24}>
                    <div className="project-modal provider_bodyvariable_box">
                      {channelEditingIndex === index ? (
                        <Form.Item
                          name={`channel_message_${index}`}
                          // initialValue={channelMessages[index]}
                          /*rules={[
                            {
                              required: true,
                              message: 'Please enter channel message',
                            },
                          ]}*/
                        >
                          <Input.TextArea
                            placeholder="Enter additional channel message"
                            rows={5}
                            // value={channelMessages[index]}
                            // onChange={(e) => handleChannelMessageChange(index, e.target.value)}
                          />
                        </Form.Item>
                      ) : (
                        <p>{channelMessages[index] || ''}</p>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
          </Form>
        </div>
      </Modal>
      <Modal
        type={'primary'}
        open={showCmsPopupInfo && cmsContent}
        footer={null}
        onCancel={closeCMSPopupInfo}
        className="modal-md"
        key={2}
        maskClosable={false}
        aria-hidden="false"
      >
        <div className="Idmodalbox earlyCheckinPopup">
          <div className="hostPayout">
            <div className="modal-content" dangerouslySetInnerHTML={{ __html: cmsContent }} />
          </div>
        </div>
      </Modal>
    </>
  );
});

export default TemplateConfig;
